"use client";
import { Close } from "@/components/newIcons/Close";
import { useStore } from "@nanostores/react";
import { useRouter } from "next/navigation";
import { PrimaryButton } from "ui/components";
import { updateUrl } from "../../_utils/searchStore";
import { Budget } from "./Budget";
import { Destinations } from "./Destinations";
import { Drawer } from "./Drawer";
import { Duration } from "./Duration";
import { Reset } from "./Reset";
import { Rythme } from "./Rythme";
import { StartMonths } from "./StartMonths";
import { Themes } from "./Themes";
import { Speakers } from "./speakers";
import { isFiltersOpenStore } from "./store";

export const Filters = () => {
  const router = useRouter();
  const isFiltersOpen = useStore(isFiltersOpenStore);

  const handleClose = () => {
    isFiltersOpenStore.set(false);
    updateUrl(router);
  };

  return (
    <>
      <Drawer open={isFiltersOpen} onClose={handleClose}>
        <div className="flex flex-col p-5">
          <div className="flex justify-between items-center pb-5 border-b border-[#E5E5E5]">
            <p className="text-xl font-bold">Filtrer</p>
            <PrimaryButton size="icon" onClick={handleClose}>
              <Close className="w-4 h-4" />
            </PrimaryButton>
          </div>
          <Duration />
          <Themes />
          <Rythme />
          <Destinations />
          <Speakers />
          <Budget />
          <StartMonths />
          <div className="flex items-center justify-between py-5">
            <Reset />
            <div className="grow" />
            <PrimaryButton onClick={handleClose}>Afficher les voyages</PrimaryButton>
          </div>
        </div>
      </Drawer>
    </>
  );
};
